import React from 'react';
import FeGridPage from './frontend-grid-page';
import CardGridPage from '@pages-clean/dummy-page/pages/card-grid-page';
import CheckboxSelectionGridPage from '@pages-clean/dummy-page/pages/checkbox-selection-grid-page';
import GridMultiValueCellPage from '@pages-clean/dummy-page/pages/grid-multi-value-cell-page';
import GridPage from '@pages-clean/dummy-page/pages/grid-page';
import VirtualizedGridPage from '@pages-clean/dummy-page/pages/virtualized-grid-page';

const GridsPage = () => {
    return (
        <>
            <CardGridPage />
            <br />
            <GridMultiValueCellPage />
            <br />
            <FeGridPage />
            <br />
            <VirtualizedGridPage />
            <br />
            <CheckboxSelectionGridPage />
            <br />
            <GridPage />
        </>
    );
};

export default GridsPage;
